var map = {
	"./bond.svg": 7125,
	"./close.svg": 1666,
	"./close1.svg": 6034,
	"./eye.svg": 5649,
	"./file.svg": 1111,
	"./flag.svg": 9520,
	"./globe.svg": 3374,
	"./layers.svg": 1703,
	"./menu.svg": 9101,
	"./out.svg": 8120,
	"./people.svg": 2845,
	"./pricelist.svg": 282,
	"./pricelist1.svg": 177,
	"./pricelist2.svg": 9527,
	"./semicircle.svg": 5116,
	"./shape1.svg": 3846,
	"./shape2.svg": 7905,
	"./shape3.svg": 4458,
	"./shape4.svg": 8846,
	"./shape5.svg": 2979,
	"./star.svg": 5810,
	"./tg.svg": 6315
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9173;